export default function MySQL_DIV() {
  return (
    <div>
      <h2>MySQL_DIV</h2>    </div>
  );
}